import { OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_IS_UNKNOWN } from '../constants/filter-operator-type';

export const addressVerificationOperatorFromFilter = (isIn, isNull) => {
  if (isIn === true) {
    return OPERATOR_TYPE_INCLUDES;
  }
  if (isNull === true) {
    return OPERATOR_TYPE_IS_UNKNOWN;
  }
};
